import { ROLL_AUTH } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface RollLoginState extends BaseAsyncReducerState {
    token: boolean | string;
    success: boolean;
    shared: null | boolean;
    captcha: null | boolean;
    addr: boolean | string;
    enotif_allowed: string;
    enotif_default: string;
    exp: number;
}
// Define an initial state value for the app
export const initialState: RollLoginState  = {
    loading: false,
    error: false,
    token: false,
    success: false,
    shared: null,
    captcha: false,
    addr: false,
    enotif_allowed: "",
    enotif_default: "",
    exp: 0
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function rollLoginReducer(state = initialState, action: AppAction): RollLoginState | Record<string, unknown> {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case ROLL_AUTH.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
            }
        case ROLL_AUTH.SUCCESS:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false,

            }
        case ROLL_AUTH.ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
                success: false,
            };
        case ROLL_AUTH.RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state
    }
}



export default rollLoginReducer;